import type { ApiError } from '@/types/api/mutations';

export type ResponseErrorData = {
  flash_type?: 'error';
  flash_message?: string;
  status?: 'error';
  errors?: ApiError[] | Record<string, string[]> | string[];
  error?: ApiError;
};

export class ResponseValidationError extends Error {
  public readonly response: { data: ResponseErrorData };
  public readonly isResponseValidationError = true;

  constructor(data: ResponseErrorData) {
    const message = data.flash_message || 'Response validation error';
    super(message);
    this.name = 'ResponseValidationError';
    this.response = { data };

    Object.setPrototypeOf(this, ResponseValidationError.prototype);
  }

  static isResponseValidationError(
    error: unknown,
  ): error is ResponseValidationError {
    return (
      error instanceof ResponseValidationError ||
      (typeof error === 'object' &&
        error !== null &&
        'isResponseValidationError' in error &&
        (error as ResponseValidationError).isResponseValidationError === true)
    );
  }
}
